<template>
 <nav class="nav-container flex justify-between items-center p-2 shadow-md sticky top-0 z-50 font-serif">
        <div class="flex items-center">
      <img src="/image/im8.png" alt="Logo HotelBook" class="h-16 w-16 text-green-600 mr-2">
      <h1 class="text-1xl font-bold text-white">University | StudentGate</h1>
    </div>
    <ul class="flex gap-8 text-white">
     <ul class="flex space-x-6 items-center">
     <router-link to="/dashboard" class="hover:text-blue-400 text-1xl transition duration-300 ">Accueil  </router-link>
     <router-link to="/cours" class="hover:text-blue-400 text-1xl transition duration-300">Cours  </router-link>
     <router-link to="/calendar" class="hover:text-blue-400 text-1xl transition duration-300">Calendrier  </router-link>
     <router-link to="/eval" class="hover:text-blue-400 text-1xl transition duration-300">Evaluation  </router-link>
     
   </ul>
   
   <li class="relative" ref="menuRef">
  <div class="flex items-center cursor-pointer" @click="toggleDropdown">
    <div class="flex flex-col items-center w-1/2 md:w-1/4">
      <div class="rounded-full overflow-hidden w-32 h-32 md:w-14 md:h-14 border-2 border-white mb-4">
        <img 
          v-if="user" 
          :src="getImageUrl(user.image)" 
          alt="Logo HotelBook" 
          class="w-full h-full object-cover" 
        />
      </div>
    </div>
  </div>

  <!-- Menu déroulant -->
  <div 
    v-if="dropdownVisible && user" 
    class="absolute top-full mt-2 right-0 w-64 bg-white border border-gray-300 rounded-lg shadow-lg p-4 z-90"
  >
  <p class="text-blue-900 text-center">Bienvenue</p>
  <div class="flex items-center mb-3">
    <img src="/image/im18.png" alt="Logo HotelBook" class="h-8 w-8 text-green-600 mr-2">
    <p class="text-gray-800 font-semibold mb-2">{{ user.surname }} {{ user.name }}</p>
  </div>
    <button 
      @click="logout" 
      class="w-full px-4 py-2 text-blue-900 bg-gray-100 rounded hover:bg-blue-900 hover:text-white transition duration-300"
    >
      Se déconnecter
    </button>
  </div>
</li>

    </ul>
   </nav>

    <section class="nav-container py-10 text-center shadow-md font-serif">
 <p class="text-gray-200">Bienvenue sur l'espace Evaluation, ici sont disponible tous les resultats de vos evaluations</p>
  <p class="text-gray-200">Lorsque vous etes sûr(e) que toutes vos notes d'un semestre donné sont disponibles vous selectionné un semeste et vous cliquez sur le bouton de téléchargement</p>

 <p class="text-gray-200">Pour toutes reclamations concernant vos notes veuillez consultez le service examen de L'UA University</p>
 <button 
     @click="downloadReleve" 
     :disabled="!selectedSemester"
     class="rounded p-2 bg-white text-blue-900 w-full md:w-auto border-2 border-white mt-8 font-serif hover:bg-blue-900 hover:text-white  transition duration-300"
   >
     Télécharger le relevé
   </button>
</section>

 <div class="bg-white flex justify-end px-4 md:px-10 pt-4 ">
   <select
  v-model="selectedSemester"
  @change="fetchEvaluationsBySemester"
  class="nav-container rounded p-2 text-white w-full md:w-1/6 border-2 border-white mt-8 font-serif"
>
  <option value="">Tous les semestres</option>
  <option v-for="n in 6" :key="n" :value="n">Semestre {{ n }}</option>
</select>

</div>

  <div v-if="loading" class="text-center text-gray-400 p-8 font-serif">
  Chargement des données...
</div>

<div v-else-if="error" class="text-red-500 text-center p-8">
  {{ error }}
</div>

<div v-else-if="evaluations.length === 0" class="text-center p-8 font-serif">
  Aucune évaluation disponible
</div>


<div v-else>

  <div class="grid grid-cols-1 md:grid-cols-4 gap-4 font-serif mt-8 px-4 md:px-8 pb-8 justify-items-center py-8 w-fit mx-auto mt-4">
    <div v-for="(evaluation, index) in paginatedCourses" :key="index" class="card">

<section class="grille w-[270px] h-4 rounded-t mb-4">
</section>

       <div class="flex items-center mb-2 hover:scale-[1.03] transform transition-all duration-300">
       <img src="/image/cour.png" alt="cours" class="h-5 w-5 mr-2" />
       <h3 class="text-1xl font-bold text-blue-900">{{ evaluation.cours }}</h3>
       
     </div>

       <div class="flex items-center">
       <img src="/image/prof.png" alt="professeur" class="h-4 w-4 mr-2" />
       <p class="text-sm text-gray-800">Professeur : {{ evaluation.prof }}</p>
     </div>
      
 <div class="flex justify-center mt-2">
         <h3 class="text-1xl font-bold text-blue-900">Resultat</h3>
       </div>

      <div class="chart-container">
        <DoughnutChart :note="evaluation.note" />
      </div>


      <div class="flex justify-center mt-2">
         <p class="text-sm" :class="{'text-green-600': evaluation.statut === 'validé', 'text-red-500': evaluation.statut === 'non validé'}">
    {{ evaluation.statut }}
  </p>
       </div>
      

    <div class="flex justify-end">
         <p class="text-xs text-gray-500">Crédit :  {{ evaluation.credit }}</p>
       </div>

    </div>
  </div>
</div>





 <div class="flex justify-center space-x-2 mt-1 mb-6 font-serif">
  <button
    @click="currentPage--"
    :disabled="currentPage === 1"
    class="px-3 py-1 bg-white text-blue-900 rounded disabled:opacity-50"
  >
       -
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="['px-3 py-1 rounded', currentPage === page ? 'bg-white text-blue-900' : 'bg-white text-gray-500']"
  >
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages"
    class="px-3 py-1 bg-white text-blue-900 rounded disabled:opacity-50 font-serif"
  >
       +
  </button>
</div>

 


  <footer class="nav-container py-4 text-center text-sm text-gray-300 font-serif">
     &copy; 2025 University StudentGate — Tous droits réservés.
   </footer>

  </template>
  
  <script>
 
import axios from 'axios';
import DoughnutChart from './DoughnutChart.vue'

export default {
  name: 'DashboardView,EvaluationCard',

   components: {
    DoughnutChart
  },


  data() {
    return {
      user: null,
      dropdownVisible: false,
     evaluations: [],
    loading: true,
    error: null,
     selectedSemester: '',
     currentPage: 1,
    itemsPerPage: 4,
    search: '',
    };
  },




computed: {
  filteredCourses() {
  if (!this.search) {
    return this.evaluations; 
  }
  return this.evaluations.filter((e) => 
    e.cours && e.cours.toLowerCase().includes(this.search.toLowerCase())
  );
},

   paginatedCourses() {
  const start = (this.currentPage - 1) * this.itemsPerPage;
  const end = start + this.itemsPerPage;
  return this.filteredCourses.slice(start, end);
},
totalPages() {
  return Math.ceil(this.filteredCourses.length / this.itemsPerPage);
},

 },






  mounted() {
    this.downloadReleve();

     this.fetchEvaluationsBySemester();


    this.fetchUser();
    document.addEventListener('click', this.closeDropdownOnClickOutside);


            
           axios.get('https://mida-back.onrender.com/api/evaluations', {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
})

.then(response => {
  console.log('Données reçues:', response.data); 
  this.evaluations = response.data || []; 
  this.loading = false;
})
.catch(error => {
  console.error('Erreur complète:', {
    status: error.response?.status,
    data: error.response?.data,
    config: error.config
  });
  this.error = error.response?.data?.message || "Erreur serveur";
  this.loading = false;
});


},



beforeUnmount() {
  document.removeEventListener('click', this.closeDropdownOnClickOutside);
  },

  methods: {


 downloadReleve() {
  if (!this.selectedSemester) return;

  this.loading = true; 
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `Bearer ${token}`
  };

  const url = `https://mida-back.onrender.com/api/evaluations/${this.selectedSemester}`;

  axios.get(url, {
    headers,
    responseType: 'blob' 
  })
  .then(response => {
    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', `releve_semestre_${this.selectedSemester}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(fileURL);
    this.loading = false;
  })
  .catch(error => {
    console.error('Erreur lors du téléchargement:', {
      status: error.response?.status,
      data: error.response?.data,
      config: error.config
    });
    this.error = "Erreur lors du téléchargement du relevé";
    alert(this.error);
    this.loading = false;
  });
},



    fetchEvaluationsBySemester() {
  this.loading = true; 
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `Bearer ${token}`
  };

  const url = this.selectedSemester === ''
    ? 'https://mida-back.onrender.com/api/evaluations'
    : `https://mida-back.onrender.com/api/evaluations/semestre/${this.selectedSemester}`;

  axios.get(url, { headers })
    .then(response => {
      console.log('Données reçues:', response.data);
      this.evaluations = response.data || [];
      this.loading = false;
    })
    .catch(error => {
      console.error('Erreur complète:', {
        status: error.response?.status,
        data: error.response?.data,
        config: error.config
      });
      this.error = error.response?.data?.message || "Erreur serveur";
      this.loading = false;
    });
},


    fetchUser() {
      axios.get('https://mida-back.onrender.com/api/user', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then((res) => {
        this.user = res.data;
      })
      .catch((error) => {
        console.error('Erreur lors du fetch de l’utilisateur connecté :', error);
      });
    },


    

    toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  },
  closeDropdownOnClickOutside(event) {
    const menu = this.$refs.menuRef;
    if (menu && !menu.contains(event.target)) {
      this.dropdownVisible = false;
    }
  },

    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      this.$router.push('/');
    },

    getImageUrl(path) {
      return path ? `https://mida-back.onrender.com/${path}` : '/image/default-users.jpg';
    }
  }
};
</script>

  
  <style scoped>
.nav-container {
  background-color: #163767;
}

.grille{
  background-color: #163767;
  height: 12px; /* hauteur visible */
  margin-left: -7%;
  margin-right: 0%;
  margin-top: -7%;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}



.card {
  width: 270px;
  max-width: 350px;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 0;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  position: relative;
}


.chart-container {
  width: 150px;
  height: 150px;
  margin: auto;
}
  /* Tu peux ajouter du style ici si tu veux */
  </style>
  